import axios from "axios";

export function loadOperation(esObjectId,id,operation) {
    return axios.get(`/api/esobject/getobjectoperation/${esObjectId}/${id}/${operation}`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
}
